import Plyr from 'plyr';

export default {
    init() {
        if ($('[data-video-player]').length) {
            $('[data-video-player]').each(function() {
                const container = $(this).find('[data-player-container]');
                const preRoll = $(this).find('[data-preroll]');
                const player = $(this).find('.plyr-vid');
                let config = {};

                if (player.data('ratio')) {
                    config.ratio = player.data('ratio');
                }

                if (player.data('controls')) {
                    config.controls = [player.data('controls')];
                }

                let vid = new Plyr(player, config);

                preRoll.click(function() {
                    const playVid = new TimelineMax();

                    vid.play();

                    playVid.set($(container), { opacity: 1 }).to($(this), 0.64, {
                        opacity: 0,
                        ease: Power2.easeOut,
                        onComplete: () => {
                            $(this).addClass('hidden');
                        }
                    });
                });
            });
        }

        if ($('.plyr').length) {
            $('.plyr').each(function() {
                const player = $(this);
                let config = {};

                if (player.data('ratio')) {
                    config.ratio = player.data('ratio');
                }

                if (player.data('controls')) {
                    config.controls = [player.data('controls')];
                }

                let vid = new Plyr(player, config);

                $('.video-launch').click(function() {
                    console.log('test');
                    vid.play();
                });
            });
        }
    }
};
